import styled from 'styled-components';
import { level1Content } from '../../../styles/shareableStyles';
import { theme } from '../../../styles/theme';

export const SettingsSection = styled.div`
  padding: 24px;
  ${level1Content};
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${theme.colors.secondary900};
`;

export const Description = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${theme.colors.secondary900};
  margin: 16px 0;
  line-height: 1.5;
`;
